import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { QueryKeys } from "@/queries/utils";
import { AdminJobDetails } from "@/queries/admin/job-details";

export const useGetNewCandidateMatches = (jobOpeningId = "") => {
  const qc = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async (data: { count: number }) => {
      const token = await getAccessTokenSilently();

      return request<{ started: boolean; blockedUntil?: string }>({
        method: "POST",
        path: `/api/admin/job_opening/${jobOpeningId}/generate_matches`,
        token,
        body: JSON.stringify({
          ...data,
        }),
      });
    },
    onSuccess: ({ started, blockedUntil }) => {
      if (!started || !blockedUntil) {
        return;
      }

      // Invalidate pipeline data
      void qc.invalidateQueries({
        queryKey: QueryKeys.adminJobPipeline,
      });

      // Mark work as in progress
      qc.setQueryData<AdminJobDetails>(
        QueryKeys.adminJobDetails(jobOpeningId),
        (old) => {
          if (!old) {
            return old;
          }

          return {
            ...old,
            candidateGenerationBlockedUntil: blockedUntil,
          };
        },
      );
    },
  });

  return {
    getNewCandidateMatches: mutate,
    isGettingNewCandidateMatches: isPending,
    getNewCandidateMatchesError: error,
  };
};
